import React from 'react'
import { Grid, GridItem } from '../../components/grid'
import css from './style.css'
import PageTitle from '../../components/page-title'

const TitleSection = props => {
  return (
    <div>
      <PageTitle title='Diamond Education' background='#fff'>
        The Kimberfire Standard
      </PageTitle>
      <Grid>
        <div className={css.pinkBg1} />
        <GridItem col='1/5' customStyle={css.gridItem} />
        <GridItem col='3/5' customStyle={css.gridItem}>
          <p className={[css.text, 'center'].join(' ')}>
            We help you maximize the size of your diamond, or minimize your budget, without going below any quality standards that will negatively impact the look of the stone. Maximizing the visual appeal of your diamond is our goal. For the quality of our diamonds and jewellery, we look to the finest brands as a benchmark. Our pricing is lower, not due to any sacrifice on quality... but because of our business model.
          </p>
        </GridItem>
        <GridItem col='1/5' customStyle={css.gridItem} />
      </Grid>
    </div>
  )
}

export default TitleSection



// WEBPACK FOOTER //
// ./src/containers/diamond/title_section.js